import * as React from 'react';
import { SVGProps } from 'react';

const IconQuestionSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM6.692 6H5c0-1.8 1.283-3 3.2-3 1.786 0 3 1.145 3 2.7 0 1.01-.42 1.741-1.3 2.3-.83.518-1.16.747-1.16 1.393l.05.607H7.14l-.07-.62c-.081-1.077.368-1.635 1.23-2.18.805-.518 1-.774 1-1.4 0-.694-.508-1.185-1.3-1.185S6.73 5.26 6.692 6zm2.416 6.047c0 .707-.43 1.144-1.13 1.144s-1.136-.437-1.136-1.144c0-.713.437-1.15 1.136-1.15.7 0 1.13.437 1.13 1.15z"
    />
  </svg>
);
export default IconQuestionSizeS;
